import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { callLogin } from "../api/login/service";


const loginSlice = createSlice({
	name: 'dataLogin',
	initialState: {
		data: null,
		isLoading: true,
		error: null
	},
	reducers: {
		setData: (state, { payload }) => {
			state.data = payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(callLogin.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(callLogin.fulfilled, (state, action) => {
				state.isLoading = false;
				if (action.payload.responseCode != "00000") {
					toast.error(action.payload.responseCode + " - " + action.payload.responseDescription, {
						position: "top-left"
					})
				} else {
					state.data = action.payload;
				}
			})
			.addCase(callLogin.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.error.message;
				toast.error(action.error.message, {
					position: "top-left"
				})
			});
	},
});
export const {
	setData
} = loginSlice.actions;
export default loginSlice.reducer;
